module.exports = __webpack_public_path__ + "img/19-ikuisuuteen.95c9972b.jpg";